/* eslint-disable import/no-extraneous-dependencies */
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
